<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      @delRow="delRow"
    >
      <page-header
        ref="header"
        slot="header"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
export default {
  components: {
    PageHeader,
    PageMain,
  },
  props: {
    tableData: {type: Array, default:() => []},
  },
  data() {
    return {
      usePage: false,
    }
  },
  methods: {
    delRow(rowId) {
      this.$emit('delRow', rowId)
    }
  },
}
</script>
